/**
 * BEWARE: using such a function is usually a cover-up for a bigger problem.
 * Executes the promise on first call and keep in cache for the [ms] provided
 */
export function cachePromiseFor<T>(ms: number, fn: () => Promise<T>) {
  type Timeout = ReturnType<typeof setTimeout>;
  let thunk: { promise: Promise<T>; timeout: Timeout } | undefined;
  return async (): Promise<T> => {
    if (!thunk) {
      thunk = {
        promise: fn(),
        timeout: setTimeout(() => {
          thunk = undefined;
        }, ms),
      };
    }
    return thunk.promise;
  };
}
